import React from 'react'
import {Card} from 'react-bootstrap'
import {useI18n} from '../../../../Utils/_helpers/useI18n'
import {PromoAction} from '../../../../../services/cellcast.v2.types'
import {Column} from '../../../../Components/shared/data-table/table'
import {KTSVG} from '../../../../../_metronic/helpers'

interface Props {
  columns: Column<PromoAction>[]
  data: PromoAction[]
  onCreateNew: () => void
}

const PromoActionHeader: React.FC<Props> = ({onCreateNew}) => {
  const {t} = useI18n()

  return (
    <Card.Header className='py-7'>
      <div className='d-flex flex-column'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-2 mb-1'>{t('PROMO_ACTION.HEADER.TITLE')}</span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            {t('PROMO_ACTION.HEADER.DESCRIPTION')}
          </span>
        </h3>
      </div>
      <div className='card-toolbar'>
        <div className='d-flex card-toolbar'>
          <button className='btn btn-primary p-4' onClick={onCreateNew}>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            {t('PROMO_ACTION.ADD_NEW')}
          </button>
        </div>
      </div>
    </Card.Header>
  )
}

export default PromoActionHeader
